import { Box, Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { NextPageWithLayout } from './_app';
import Image from 'next/image';

const ShippingServiceChargePage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>การจัดส่งสินค้าและค่าบริการ | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={`การจัดส่งสินค้าและค่าบริการ`}></PageHeader>
        <PageTitleMobile>{`การจัดส่งสินค้าและค่าบริการ`}</PageTitleMobile>
        <Container
          pt={{
            base: 10,
            md: 14,
          }}
          pb={{
            base: 10,
            md: 20,
          }}
        >
          <Heading fontWeight="500" mb={0}>
            เงื่อนไขค่าจัดส่งสำหรับการสั่งซื้อออนไลน์ (LAMPTAN SHOP ONLINE)
          </Heading>
          <Heading fontWeight="500" mb={6}>
            ผ่านเว็บไซต์ www.lamptan.co.th เท่านั้น
          </Heading>
          <Text mb={10}>
            จัดส่งสินค้าโดยขนส่งเอกชนโดยคำนวนตามน้ำหนักรวมของสินค้าทั้งหมดในแต่ละคำสั่งซื้อ
          </Text>

          <Box borderBottom="1px solid #eee" pb={8} mb={10}>
            <Heading as="h5" fontSize="lg" fontWeight={400} mb={3}>
              จัดส่งแบบลงทะเบียน
            </Heading>
            <Text mb={4}>
              การจัดส่งแบบลงทะเบียน น้ำหนักรวมของสินค้าต้องไม่เกิน 2,000 กรัม (2
              กิโลกรัม)
            </Text>
            <Box>
              <Box mb={6}>
                <Image
                  src="/pages/delivery-table-register.jpg"
                  width={1000}
                  height={1000}
                  alt="delivery-table-register"
                />
              </Box>
              <Text fontWeight={400}>ระยะเวลาการจัดส่ง</Text>
              <Text>
                ท่านจะได้รับสินค้าภายใน 4 ถึง 7 วัน ขึ้นอยู่กับพื้นที่การจัดส่ง
              </Text>
            </Box>
          </Box>

          <Box>
            <Heading as="h5" fontSize="lg" fontWeight={400} mb={3}>
              จัดส่งแบบ EMS
            </Heading>
            <Box borderBottom="1px solid #eee" pb={8} mb={10}>
              <Box mb={4} pb={4}>
                <Image
                  src="/pages/delivery-table-ems.png"
                  width={1000}
                  height={1000}
                  alt="delivery-table-ems"
                />
              </Box>
              <Text fontWeight={500}>ระยะเวลาการจัดส่ง</Text>
              <Text>
                ท่านจะได้รับสินค้าภายใน 1 ถึง 3 วัน ขึ้นอยู่กับพื้นที่การจัดส่ง
              </Text>
            </Box>

            <Box>
              <Text mb={6}>
                การจัดส่งสินค้าโดยขนส่งเอกชน
                ท่านสามารถตรวจสอบสถานะการจัดส่งจากเลขแทรคกิ้ง
                (หมายเลขติดตามพัสดุ)
                ในรายการสั่งซื้อของฉันในบัญชีของท่านในเว็บไซต์ LAMPTAN Shop
                Online
              </Text>
              <Text mb={6}>
                ในกรณีที่สินค้ามีน้ำหนักหรือขนาดเกินกำหนดในการจัดส่งโดยขนส่งเอกชน
                ทางบริษัทจะทำการติดต่อท่านเพื่อ
                ทำการนัดวันส่งสินค้าและแจ้งค่าจัดส่งสินค้าให้ท่านภายใน 2
                วันทำการ
              </Text>

              <Text>
                **ในกรณีค่าขนส่งมีการเปลี่ยนแปลง
                ทางบริษัทขออนุญาตติดต่อกลับลูกค้า**
              </Text>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

ShippingServiceChargePage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common'])),
    },
  };
},
sessionOptions);

export default ShippingServiceChargePage;
